import { render } from "./CompanyInfoPage.vue?vue&type=template&id=abc8cc26&ts=true"
import script from "./CompanyInfoPage.vue?vue&type=script&lang=ts"
export * from "./CompanyInfoPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__